const articles = [
  {
    title:
      "The S&P 500 ESG Index: Integrating Environmental, Social, and Governance Values into the Core. The S&P 500 ESG Index: Integrating Environmental, Social, and Governance Values into the Core.",
    subtitle: "Discover the risk/return benefits of a new path to Core.",
    image:
      "https://www.spindices.com/images/indexology-microsite/microsite-esg-bridge-1340x400.jpg",
    url:
      "https://us.spindices.com/indexology/esg/the-sp-500-esg-index-integrating-environmental-social-and-governance-values-into-the-core?_ga=2.87568862.779812052.1554914122-937757268.1534339485",
  },
  {
    title: "UBS to launch first S&P 500 ETF with ESG screening",
    subtitle:
      "UBS Asset Management has announced the upcoming launch of the UBS ETF S&P 500 ESG UCITS ETF in Europe which will provide a passive vehicle for socially responsible investment into the US large-cap equity market.",
    image:
      "https://i0.wp.com/www.etfstrategy.com/wp-content/uploads/2012/10/clemens-reuter-ubs-etfs.jpg?w=300&ssl=1",
    url:
      "https://www.etfstrategy.com/ubs-launches-first-sp-500-etf-with-esg-screening-10448/",
  },
  {
    title:
      "How Board Members Really Feel About ESG, from Deniers to True Believers",
    subtitle:
      "Driving sustainable business practices in companies requires involvement from boards of directors.",
    image:
      "https://hbr.org/resources/images/article_assets/2019/04/Apr19_19_690637969-768x432.jpg",
    url:
      "https://hbr.org/2019/04/how-board-members-really-feel-about-esg-from-deniers-to-true-believers?",
  },
  {
    title:
      "How Sustainable And Impact Investing Can Increase Investor Resilience And Decrease The Performance Gap",
    subtitle:
      "Jina Penn-Tracy, co-founder of Centered Wealth, discusses her new research suggesting that socially responsible investing can improve investor returns by changing investor behavior.",
    image: "",
    url:
      "https://www.fa-mag.com/news/how-sustainable-and-impact-investing-can-increase-investor-resilience-and-decrease-the-performance-gap-44176.html",
  },
  {
    title:
      "Vigeo Eiris and Moody’s Investors Service join forces to celebrate the recognition and the value of non-credit evaluations",
    subtitle:
      "Confirming their shared common goals, Vigeo Eiris has accepted Moody's Investors Service’s offer to become its majority shareholder. This decision was unanimously approved by Vigeo Eiris’ Board of Directors on March 27, 2019.",
    image:
      "http://www.vigeo-eiris.com/wp-content/uploads/2017/10/VigeoEiris-RVB-Social.jpg",
    url:
      "http://www.vigeo-eiris.com/vigeo-eiris-and-moodys-investors-service-join-forces-to-celebrate-the-recognition-and-the-value-of-non-credit-evaluations/",
  },
  {
    title:
      "More Funds Are Formally Considering ESG in Their Investment Processes",
    subtitle:
      "The number of actively managed funds that are adding environmental, social, and governance criteria to their prospectuses is exploding. ",
    image: "",
    url:
      "https://www.morningstar.com/articles/922371/more-funds-are-formally-considering-esg-in-their-i.html?utm_content=bufferb9699&utm_medium=social&utm_source=linkedin.com&utm_campaign=buffer",
  },
  {
    title: "60 Investors Commit to Manage over $350 Billion",
    subtitle:
      "60 Investors Commit to Manage over $350 Billion in Assets in Line with New Impact Principles.",
    image: "",
    url:
      "http://www.scoop.co.nz/stories/WO1904/S00100/60-investors-commit-to-manage-over-350-billion.htm",
  },
  {
    title: "SASB on where to make sustainability disclosures",
    subtitle:
      "When SASB started, part of its mission was to encourage companies to make material sustainability disclosures in their financial filings like the 10K.",
    image: "https://www.theice.com/publicdocs/images/NYSE_Webinar_Hero.jpg",
    url:
      "https://www.intercontinentalexchange.com/about/corporate-responsibility/resources-listed-companies/sasb",
  },
  {
    title: "The Rise of Impact Investing",
    subtitle: "International Monetary Fund",
    image: "",
    url:
      "https://www.linkedin.com/feed/update/urn:li:ugcPost:6522487720470814720",
  },
  {
    title: "The S&P 500 Gets an ESG Makeover — but It May Not Go Far Enough",
    subtitle:
      "Fund companies are making it easier to change the world. Or maybe not.",
    image: "https://images.barrons.com/im-66095?width=1260&aspect_ratio=1.5",
    url:
      "https://www.barrons.com/articles/the-s-p-500-gets-an-esg-makeover-but-it-may-not-go-far-enough-51554998715",
  },
  {
    title:
      "The ESG Weekly: Norsk Hydro's NASA Fraud and Marriot Goes Gig Economy on the Week of April 29",
    subtitle:
      "Two stories this week with ESG glasses: Norsk Hydro's subsidiary pays NASA for false metal testing (0:58) and Marriott looks to AirBnB for inspiration (7:36), all on the record",
    image: "https://secureimg.stitcher.com/feedimageswide/480x270_233837.jpg",
    url: "https://www.stitcher.com/podcast/msci-esg-research-llc/esg-now",
  },
  {
    title:
      "Executive Order on Promoting Energy Infrastructure and Economic Growth",
    subtitle:
      "By the authority vested in me as President by the Constitution and the laws of the United States of America, it is hereby ordered as follows:",
    image: "",
    url:
      "https://www.whitehouse.gov/presidential-actions/executive-order-promoting-energy-infrastructure-economic-growth/",
  },
  {
    title: "Bloomberg and MSCI Expand ESG Fixed Income Index Suite into Canada",
    subtitle:
      "BlackRock among the first clients to license the index for a suite of Canadian ESG ETFs",
    image:
      "https://data.bloomberglp.com/professional/sites/10/4-6-2017-6-40-06-PM.png",
    url:
      "https://www.bloomberg.com/company/announcements/bloomberg-msci-expand-esg-fixed-income-index-suite-canada/",
  },
  {
    title: "ESG ASSET OWNERS SUMMIT",
    subtitle: "The Rise & Status of Sustainable Investing",
    image:
      "https://www.cfasociety.org/washingtondc/PublishingImages/Lists/Events%20Calendar/calendar/ESG2.jpg",
    url:
      "https://www.cfasociety.org/washingtondc/Lists/Events%20Calendar/DispForm.aspx?ID=586&Source=https://www.cfasociety.org/washingtondc/Lists/Events%2520Calendar/calendar.aspx",
  },
  {
    title: "Global sustainable investing assets surged to $30 trillion in 2018",
    subtitle:
      "Sustainable investment has surged worldwide by more than a third since 2016, reaching assets of more than $30 trillion at the start of last year, new global financial analysis released last week has found.",
    image:
      "https://www.greenbiz.com/sites/default/files/styles/gbz_article_primary_breakpoints_kalapicture_screen-lg_1x/public/images/articles/featured/investatstockproductionssstock.jpg?itok=7N2B7h7q&timestamp=1554494408",
    url:
      "https://www.greenbiz.com/article/global-sustainable-investing-assets-surged-30-trillion-2018",
  },
  {
    title: "Impact Investments Under Management Total $502 Billion",
    subtitle:
      "The impact investing market has grown exponentially since the term was coined in 2007 to describe investments that lead to social and/or environmental benefits as well as a financial return.",
    image:
      "https://asset.barrons.com/public/resources/images/ON-CY147_magnol_G_20190401145434.jpg",
    url:
      "https://www.barrons.com/articles/impact-investments-under-management-total-504-billion-01554145026",
  },
]

const negativeArticles = [
  {
    title: "Lush to remove mica from all products over child labour fears",
    subtitle:
      "https://www.theguardian.com/sustainable-business/lush-removes-mica-child-labour",
    image:
      "https://i.guim.co.uk/img/static/sys-images/Money/Pix/pictures/2008/03/28/LushMartinArglesGuardian460.jpg?width=620&quality=85&auto=format&fit=max&s=692ba725210621b2ffe1136b1235455e",
    url:
      "https://www.theguardian.com/sustainable-business/lush-removes-mica-child-labour",
  },
  {
    title: "Brazil dam collapse: 10 bodies found and hundreds missing",
    subtitle:
      "Chance of finding survivors ‘minimal’ after tailings dam at iron ore mine bursts",
    image:
      "https://i.guim.co.uk/img/media/d4e2f9e08d20cf1a52dff34ea1334c86374ddb32/0_0_4451_2971/master/4451.jpg?width=780&quality=85&auto=format&fit=max&s=28c0521c56f3bcaf018c9d2ad84a8811",
    url:
      "https://www.theguardian.com/world/2019/jan/25/brazil-dam-collapse-news-latest-mining-disaster-brumadinho",
  },
  {
    title:
      "Exxon Valdez changed the oil industry forever—but new threats emerge",
    subtitle:
      "Thirty years ago, a spill in Alaska shocked the world. Tankers got safer, but they're not the only risks.",
    image:
      "https://www.nationalgeographic.com/content/dam/environment/2019/03/oil-spill/01_oilspill_gettyimages-167171359.adapt.590.1.jpg",
    url:
      "https://www.nationalgeographic.com/environment/2019/03/oil-spills-30-years-after-exxon-valdez/",
  },
  {
    title: "The Minor Miners - Stop child mining in Africa",
    subtitle:
      "The film 'The Minor Miners' is about the plight of child labor in Mali and the dreadful experiences of the children who are artisanal child miners in Mali. ",
    image: "http://i3.ytimg.com/vi/ZdRycPrraGI/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=ZdRycPrraGI",
  },
  {
    title:
      "Exxon Valdez changed the oil industry forever—but new threats emerge",
    subtitle:
      "Thirty years ago, a spill in Alaska shocked the world. Tankers got safer, but they're not the only risks.",
    image:
      "https://www.nationalgeographic.com/content/dam/environment/2019/03/oil-spill/01_oilspill_gettyimages-167171359.adapt.590.1.jpg",
    url:
      "https://www.nationalgeographic.com/environment/2019/03/oil-spills-30-years-after-exxon-valdez/",
  },
]

export { articles, negativeArticles }
